/* main.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./main.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { di } from 'react-magnetic-di';
import { Box } from '@atlaskit/primitives/compiled';
import { useHubContext } from '@atlassian/company-hub-common';
import { Banner } from './banner';
import { Navbar } from './navbar';
var containerStyles = {
  bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
  container: "_19itglyw _2rkopd34 _1reo1wug _18m91wug _vchhusvi _r06hglyw _kqswh2mm _16qs1cd0 _bfhkhp5a _1tke1osq _1e0c1txw _2lx21bp4"
};
export var HubAppShell = function HubAppShell(_ref) {
  var children = _ref.children;
  var _useHubContext = useHubContext(),
    layout = _useHubContext.layout;
  var showBanner = layout === null || layout === void 0 ? void 0 : layout.showBanner;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: containerStyles.container
  }, /*#__PURE__*/React.createElement(Navbar, null), showBanner && /*#__PURE__*/React.createElement("div", {
    className: ax([containerStyles.bannerContainer])
  }, /*#__PURE__*/React.createElement(Banner, null)), children);
};